module.exports = __webpack_public_path__ + "static/img/exhibitFormTips2.8adc7151.png";